export default __webpack_public_path__ + "static/media/appStore1.8e711662.png";